(function () {
    let $body = $('body');

    let list = {
        expandIcon: 'icon-add_box',
        collapseIcon: 'icon-squared-minus',

        init: function () {
            list.on.build();
            list.control();
        },
        control: function () {
            $body.on('click', '.expandable-list__toggle', function (e) {
                e.preventDefault();
                list.on.toggleList($(this));
            });
        },
        on: {
            build: function () {
                let $wrapper = $('.expandable-list');

                $wrapper.each(function () {
                    let $target = $(this).find('.expandable-list__body');
                    $target.hide();
                });
            },

            toggleList: function (elem) {
                let $toggle = elem,
                    $wrapper = $toggle.closest('.expandable-list'),
                    $target = $wrapper.children('.expandable-list__body').toggle();
                list.defineToggleIcons($wrapper);

                $wrapper.toggleClass('js--open');
                $toggle.find('i').toggleClass(list.expandIcon + ' ' + list.collapseIcon);

                if ($wrapper.hasClass('js--open')) {
                    $toggle.attr('aria-expanded', true);
                    $target.attr('aria-hidden', false);
                } else {
                    $toggle.attr('aria-expanded', false);
                    $target.attr('aria-hidden', true);
                }
            },
            closeList: function (elem) {
                let $wrapper = $('.expandable-list');
                list.defineToggleIcons($wrapper);
                $wrapper.removeClass('js--open');
                let $target = $wrapper.children('.expandable-list__body').hide();
                let $toggle = $('.expandable-list__toggle');

                $toggle
                    .attr('aria-expanded', 'false')
                    .find('i')
                    .addClass(list.expandIcon)
                    .removeClass(list.collapseIcon);
                $target.attr('aria-hidden', true);
            },
        },
        defineToggleIcons($expandableList) {
            if ($expandableList.data('expand-icon') !== undefined && $expandableList.data('expand-icon') !== '') {
                list.expandIcon = $expandableList.data('expand-icon');
            }

            if ($expandableList.data('collapse-icon') !== undefined && $expandableList.data('collapse-icon') !== '') {
                list.collapseIcon = $expandableList.data('collapse-icon');
            }
        },
    };

    UX.list = list; // add to global namespace
})();
